import { CSSObject } from '@chakra-ui/react';

export const TabsContentContainer: CSSObject = {
  px: ['2.5', '4'],
  py: '0',
};
